export const GET_ALERTS = 'GET_ALERTS';
export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS';
export const GET_ALERTS_FAILURE = 'GET_ALERTS_FAILURE';
export const DELETE_ALERTS = 'DELETE_ALERTS';
export const DELETE_ALERTS_SUCCESS = 'DELETE_ALERTS_SUCCESS';
export const DELETE_ALERTS_FAILURE = 'DELETE_ALERTS_FAILURE';
export const MARK_ALERTS_READ = 'MARK_ALERTS_READ';
export const MARK_ALERTS_READ_SUCCESS = 'MARK_ALERTS_READ_SUCCESS';
export const MARK_ALERTS_READ_FAILURE = 'MARK_ALERTS_READ_FAILURE';
export const GET_FILTER_DISTRICTS = 'ALERTS_FILTER_DISTRICTS';
export const GET_FILTER_TERRITORIES = 'ALERTS_FILTER_TERRITORIES';
export const GET_FILTER_ACCOUNTS = 'ALERTS_FILTER_ACCOUNTS';
export const GET_FILTER_DISTRICTS_SUCCESS = 'ALERTS_FILTER_DISTRICTS_SUCCESS';
export const GET_FILTER_TERRITORIES_SUCCESS = 'ALERTS_FILTER_TERRITORIES_SUCCESS';
export const GET_FILTER_ACCOUNTS_SUCCESS = 'ALERTS_FILTER_ACCOUNTS_SUCCESS';
export const GET_FILTER_DISTRICTS_FAILURE = 'ALERTS_FILTER_DISTRICTS_FAILURE';
export const GET_FILTER_TERRITORIES_FAILURE = 'ALERTS_FILTER_TERRITORIES_FAILURE';
export const GET_FILTER_ACCOUNTS_FAILURE = 'ALERTS_FILTER_ACCOUNTS_FAILURE';
export const SET_FILTER_ALERT = 'SET_FILTER_ALERT';
export const SET_SEARCHBAR_TEXT = 'SET_SEARCHBAR_TEXT';
export const RESET_ALERTS_LIST = 'RESET_ALERTS_LIST';
export const SET_SELECTED_ALERT_IDS = 'SET_SELECTED_ALERT_IDS';

const DEFAULT_ALERTS_SORT_BY = 'alertDate';

export const setSelectedAlertIds = (payload = []) => ({
    type: SET_SELECTED_ALERT_IDS,
    payload,
});

export const resetAlertsList = () => ({
    type: RESET_ALERTS_LIST,
});

export const getAlerts = (payload = {}) => ({
    type: GET_ALERTS,
    payload: { ...payload, sortBy: payload.sortBy || DEFAULT_ALERTS_SORT_BY },
});

export const deleteAlerts = (payload = {}) => ({
    type: DELETE_ALERTS,
    payload,
});

export const markAlertsRead = (payload = {}) => ({
    type: MARK_ALERTS_READ,
    payload,
});

export const getFilterDistricts = (payload = {}) => ({
    type: GET_FILTER_DISTRICTS,
    payload,
});

export const getFilterTerritories = (payload = {}) => ({
    type: GET_FILTER_TERRITORIES,
    payload,
});

export const getFilterAccounts = (payload = {}) => ({
    type: GET_FILTER_ACCOUNTS,
    payload,
});


export const setFilterAlert = (payload = {}) => ({
    type: SET_FILTER_ALERT,
    payload,
});

export const setSearchbarText = (payload = {}) => ({
    type: SET_SEARCHBAR_TEXT,
    payload,
});
